import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserRole } from '@src/types/user';

interface ModalState {
  selected: {
    userId: null | number;
    role: UserRole;
    name: string;
  };
  addManagerModal: boolean;
  editInfoModal: boolean;
  editManagerRoleModal: boolean;
  deleteConfirmModal: { type: 'COMPANY' | 'MANAGER'; isOpen: boolean };
}

const initialState: ModalState = {
  selected: {
    userId: null,
    role: 'member',
    name: '',
  },
  addManagerModal: false,
  editInfoModal: false,
  editManagerRoleModal: false,
  deleteConfirmModal: { type: 'COMPANY', isOpen: false },
};

const modalSlice = createSlice({
  name: 'companyDetailModal',
  initialState,
  reducers: {
    handleSelected(state, { payload }) {
      state.selected = payload;
    },
    handleAddManagerModal(state) {
      state.addManagerModal = !state.addManagerModal;
    },
    handleEditInfoModal(state) {
      state.editInfoModal = !state.editInfoModal;
    },
    handleEditManagerRoleModal(state) {
      state.editManagerRoleModal = !state.editManagerRoleModal;
    },
    handleDeleteConfirmModal(
      state,
      {
        payload,
      }: PayloadAction<{ type?: 'COMPANY' | 'MANAGER'; isOpen: boolean }>
    ) {
      state.deleteConfirmModal = { ...state.deleteConfirmModal, ...payload };
    },
  },
});

export const {
  handleSelected,
  handleAddManagerModal,
  handleEditInfoModal,
  handleEditManagerRoleModal,
  handleDeleteConfirmModal,
} = modalSlice.actions;

export default modalSlice.reducer;
